import { render, staticRenderFns } from "./QuestionsContainer.vue?vue&type=template&id=5ced6104&scoped=true"
import script from "./QuestionsContainer.vue?vue&type=script&lang=js"
export * from "./QuestionsContainer.vue?vue&type=script&lang=js"
import style0 from "./QuestionsContainer.vue?vue&type=style&index=0&id=5ced6104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced6104",
  null
  
)

export default component.exports